import axios from "./axios";

export const getEventList = async (type, id, meta) => {
  try {
    let url = `/api/v1/provision/${type}/${id}?op=list.events&page=${meta.current}&size=${meta.pageSize}`;
    if(meta.sorters && meta.sorters.length > 0){
      let sorter = meta.sorters[0];
      url = url + `&sortBy=${sorter.order.charAt(0)},${sorter.field}`
    }
    const data = await axios.get(url);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
